import { render, staticRenderFns } from "./memberHome.vue?vue&type=template&id=28ec922e&scoped=true"
import script from "./memberHome.vue?vue&type=script&lang=js"
export * from "./memberHome.vue?vue&type=script&lang=js"
import style0 from "./memberHome.vue?vue&type=style&index=0&id=28ec922e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec922e",
  null
  
)

export default component.exports